var BEES = require('serialisers/byte-encoded-enum-serialiser');
var WillRegistrationResult = require('./will-registration-result');

var serialiser = {
    read : function(input) {
        return BEES.read(input, WillRegistrationResult);
    },
    write : function(output, result) {
        BEES.write(output, result);
    }
};

module.exports = serialiser;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/wills/will-registration-result-serialiser.js
// module id = 1716
// module chunks = 1